import customAxios from "../../customAxios";
import { DELETE_AREA } from "../../routes";

const deleteArea = async (id: string) => {
  try {
    return (await customAxios.delete(DELETE_AREA + `/${id}`)).data;
  } catch (error: any) {
    console.log({ DELETE_AREA: error });
    return false;
  }
};

export default deleteArea;
